<template>
  <section id="Infos" class="bg-white">
    <div class="container py-5">
      <div class="row py-5">
        <div class="col-12" data-aos="fade-up" data-aos-delay="500">
          <h2 class="mb-5">Technik</h2>
          <p class="text-dark">Ich nutze nur moderne, namenhafte und professionelle Licht- und Tontechnik.</p>
          <p class="text-dark">Die Größe der Musikanlage richtet sich natürlich auch nach der Größe Ihrer Feier.</p>
          <p class="text-dark">Selbstverständlich werden die Größe und Vielfalt der Anlage im Vorfeld zwischen uns besprochen. Sie können sich bei mir aber immer auf einen perfekten Sound verlassen.</p>
          <p class="text-dark">Die Anlage steht, bevor die ersten Gäste eintreffen.<br>Für den Aufbau benötige ich ca. 60 bis 90 Minuten. Die Zeit kann aufgrund der Größe der Veranstaltung und des damit erforderlichen Equipments etwas variieren.</p>
        </div>
      </div>
      <div class="row py-5">
        <div class="col-12" data-aos="fade-up" data-aos-delay="500">
          <h2 class="mb-5">Moderation</h2>
          <p class="text-dark">Auf privaten Feiern halte ich mich in der Regel sehr zurück. Meine Moderation beschränkt sich meist auf kurze Ansagen sofern nichts anderes besprochen wurde.</p>
          <p class="text-dark">Kurz gesagt: Wenn es gewünscht wird, weiß ich zu moderieren und animieren. Ansonsten gibt es von mir eher gute Musik als laute Sprüche.</p>
        </div>
      </div>
      <div class="row py-5">
        <div class="col-12" data-aos="fade-up" data-aos-delay="500">
          <h2 class="mb-5">Preis und Bezahlung</h2>
          <p class="text-dark">Im Preis enthalten ist, neben meiner DJ - Tätigkeit, eine professionelle Musikanlage, ein Kabel- oder Funkmikrofon sowie eine ausreichende Lichtanlage auf LED-Beleuchtungsbasis.</p>
          <p class="text-dark">Dabei kann man wählen zwischen den drei Paketen.</p>
          <p class="text-dark">Meine Bezahlung erhalte ich in der Regel am Ende meines Services in bar. Es besteht auch die Möglichkeit die Gage zu überweisen.</p>
          <p class="text-dark">Alle angegebenen Preise sind Endpreise zzgl. Anfahrtskosten. Aufgrund des Kleinunternehmerstatus gem. §19 UStG erhebe ich keine Umsatzsteuer und weise diese daher auch nicht aus.</p>
        </div>
      </div>
      <div class="row py-5">
        <div class="col-12" data-aos="fade-up" data-aos-delay="500">
          <h2 class="mb-5">Wirkungskreis</h2>

          <p class="text-dark mb-0">Alb Donau Kreis:</p>
          <small>Ulm, Biberach, Blaubeuren, Ehingen, Geislingen, Laupheim, Münsingen, Riedlingen, Nellingen..</small>

          <p class="text-dark mb-0 mt-3">Dillingen an der Donau:</p>
          <small>Dillingen, Gundelfingen, Lauingen, Bachhagel, Mödingen, Höchstädt an der Donau, Finningen, Wertingen..</small>

          <p class="text-dark mb-0 mt-3">Günzburg:</p>
          <small>Günzburg, Burgau, Ichenhausen, Krumbach, Leipheim, Thannhausen, Jettingen-Scheppach, Wörleschwang..</small>

          <p class="text-dark mb-0 mt-3">Donau Ries:</p>
          <small>Donauwörth, Nördlingen, Rain, Tapfheim..</small>

          <p class="text-dark mb-0 mt-3">Göppingen:</p>
          <small>Göppingen, Salach, Donzdorf, Essingen, Uhingen, Geislingen an der Steige, Böhmenkirch, Laichingen, Neuffen..</small>

          <p class="text-dark mb-0 mt-3">Schwäbisch Gmünd:</p>
          <small>Schwäbisch Gmünd, Lorch, Kaisersbach, Rudersberg, Durlangen..</small>

          <p class="text-dark mb-0 mt-3">Schwäbisch Hall:</p>
          <small>Schwäbisch Hall, Stimpfach-Rechenberg, Langenburg, Schwäbisch Hall-Veinau..</small>

          <p class="text-dark mb-0 mt-3">Ostalbkreis:</p>
          <small>Aalen, Bartholomä, Essingen, Lauchheim, Bopfingen, Ellwangen, Abtsgmünd, Heubach, Neresheim..</small>

          <p class="text-dark mb-0 mt-3">Heidenheim an der Brenz:</p>
          <small>Heidenheim an der Brenz, Herbrechtingen, Nattheim, Königsbronn, Gerstetten Niederstotzingen, Dischingen, Sontheim an der Brenz, Giengen an der Brenz..</small>

          <p class="text-dark mb-0 mt-3">Landkreis Neu-Ulm:</p>
          <small>Neu-Ulm, Finningen, Nersingen, Elchingen, Illertissen, Weißenhorn, Senden, Vöhringen..</small>

          <p class="text-dark mb-0 mt-3">Rems-Murr-Kreis:</p>
          <small>Waiblingen, Schorndorf, Fellbach, Backnang, Remseck, Urbach, Rudersberg..</small>

          <p class="text-dark mb-0 mt-3">Ravensburg:</p>
          <small>Ravensburg, Bad Waldsee, Bad Wurzach, Wangen im Allgäu, Weingarten, Leutkirch im Allgäu, Isny im Allgäu..</small>

        </div>
      </div>
      <div class="row py-5">
        <div class="col-12" data-aos="fade-up" data-aos-delay="200">
          <h2 class="mb-5">Meine Partner</h2>
          <a href="https://markus-wolf.info/" target="_blank"><img src="@/assets/img/markuswolf.png"></a>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>

</script>

<style scoped>

</style>